/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
 import http from "@/http";
 import * as types from "./types";

const actions = {
  /**
  * Fetch the New Tabs List Metadata to use with the Atomic Swatch Tray
  * @param {string} modelName - PDM model
  *
  */
  [types.GET_SWATCH_TABS_METADATA](context, modelName) {
    const model = modelName || this.state.utils.pdmModel;
    const { tabMetaData } = this.state.endPoints.customizer;
    const enablePerformanceLogging = this.state.utils.queryParams.enablePerformanceLogging || this.state.utils.configuration.enablePerformanceLogging;
    const requestUrl = `${tabMetaData}/${model}`;

    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          context.commit(types.SET_SWATCH_TABS, data);
          if(enablePerformanceLogging)
            console.log("Tabs Ready: ", new Date().getTime() / 1000 - this.state.utils.initialTime);
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;